import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import { selectAccessToken, selectUserCredentials } from '../../../features/auth/auth-slice';
import { DEPARTMENT_CODES } from '../../../constant/department-code-constant';

export default function GuestRoute() {
    const token = useSelector(selectAccessToken);
    const user = useSelector(selectUserCredentials);

    // RULE 1: Only redirect away from login if the user has an active token AND user data
    if (token && user?.departmentCode) {
        switch (user.departmentCode) {
            case DEPARTMENT_CODES.MKT_GMS:
                return <Navigate to="/status-proposal" replace />;
            case DEPARTMENT_CODES.EBAM:
                return <Navigate to="/policy-creation" replace />;
            case DEPARTMENT_CODES.IT:
                return <Navigate to="/user-management" replace />;
            case DEPARTMENT_CODES.ACTUARIAL:
                return <Navigate to="/computation-proposal" replace />;
            default:
                return <Navigate to="/my-account" replace />;
        }
    }

    // RULES 2 & 3: If token/user is missing (e.g. fresh load or expired), 
    // allow them to view the login page normally instead of rendering null.
    return <Outlet />;
}